import { call, put, delay } from "redux-saga/effects";
import { categoryApi } from "@services/api";
import { getTopCategoriesActions } from "../slices";

function* getTopCategoriesWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getTopCategoriesActions.pending());
    const response = yield call(categoryApi.getTopCategories, payload);
    yield put(getTopCategoriesActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getTopCategoriesActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getTopCategoriesWorker };
